module.exports = __webpack_public_path__ + "img/antikommunistischer_Widerstand_kl.02080d8a.jpg";